import { Box, Container } from "@mui/material";
import { t } from "@lingui/macro";
import { useHistoricalFitnessProfiles } from "./useHistoricalFitnessProfiles";
import { HistoricalFitnessProfileCard } from "./HistoricalFitnessProfileCard";
import { AthleteProfileCard, WfQuickFilter } from "@WahooFitness/redesignr";
import AthleteProfileWithCyclistSvg from "./AthleteProfileWithCyclistSvg";
import useFitnessAssessmentClickHandler from "@/hooks/useFitnessAssessmentClickHandler";
import { SourcePage } from "@/services/Analytics/EventTypes";
import { ErrorBoundary, GlobalHeader } from "@WahooFitness/wahoo-offline-mfe";
import HistoryBlankState from "./HistoryBlankState";

const HistoricalFitnessProfiles = () => {
  const {
    openId,
    handleAccordionChange,
    selectedFilters,
    handleFilterChange,
    filteredHistoricalData,
    showAssessmentPrompt,
    handleFitnessAssessmentClose,
    handleViewWorkoutDetails,
    filterButtons,
    isLoading,
    error,
  } = useHistoricalFitnessProfiles();

  const { handleFitnessTestClick } = useFitnessAssessmentClickHandler(
    SourcePage.historical_fitness_profiles
  );
  return (
    <>
      <GlobalHeader title={t`Profile historical view`} />
      <Container maxWidth="sm" disableGutters sx={{ minHeight: "100%" }}>
        <ErrorBoundary isLoading={isLoading} error={error} onReload={() => {}}>
          <Box p={2} gap={2} display="flex" flexDirection="column">
            <WfQuickFilter
              filters={filterButtons}
              selectedFilters={selectedFilters}
              onClick={handleFilterChange}
            />

            {showAssessmentPrompt && (
              <AthleteProfileCard
                imageComponent={<AthleteProfileWithCyclistSvg />}
                title={t`Retake fitness assessment`}
                time={t`59 min`}
                actionText={t`Start fitness assessment`}
                description={t`It’s been a while since your last fitness assessment. Take a fitness assessment to update your profile and keep your training personalized and effective.`}
                onActionClick={handleFitnessTestClick}
                size="large"
                variant="elevation"
                onClose={handleFitnessAssessmentClose}
              />
            )}

            {!showAssessmentPrompt && !filteredHistoricalData.length && <HistoryBlankState />}

            {filteredHistoricalData.map((profile) => (
              <HistoricalFitnessProfileCard
                key={profile.id}
                profile={profile}
                expanded={openId === profile.id}
                onChange={() => handleAccordionChange(profile.id)}
                handleViewWorkoutDetails={handleViewWorkoutDetails}
              />
            ))}
          </Box>
        </ErrorBoundary>
      </Container>
    </>
  );
};

export default HistoricalFitnessProfiles;
